import script from "./BaseProgressBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseProgressBar.vue?vue&type=script&lang=ts&setup=true"

import "./BaseProgressBar.vue?vue&type=style&index=0&id=b8b114ea&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8b114ea"]])

export default __exports__